import { ArrowRightOutlined } from '@ant-design/icons'
import { motion } from 'framer-motion'

import React from 'react'

import furnitureImage from '../../assets/images/chair.png'
import ButtonCatalog from '../button-catalog'

import './style.scss'

const ResponsiveFurnitureCard = ({
  title = 'Прикроватные кровать',
  buttonText = 'Перейти в каталог',
  image = furnitureImage,
  onButtonClick = () => null,
  isExpanded,
  backgroundColor,
}) => {
  return (
    <motion.div
      className="responsive-furniture-card"
      style={{
        backgroundImage: `url(${image})`,
        backgroundColor: backgroundColor,
        backgroundBlendMode: 'multiply',
      }}
      animate={{
        backgroundColor: isExpanded ? backgroundColor : 'rgba(255, 255, 255, 0)',
      }}
      transition={{ duration: 0.5 }}
    >
      <div className="content">
        <h2 className="title">{title}</h2>
        <ButtonCatalog
          buttonText={buttonText}
          onButtonClick={onButtonClick}
        />
      </div>
    </motion.div>
  )
}

export default ResponsiveFurnitureCard
